"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ContentRows = void 0;
var _productList = require("@ori/product-list");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _contexts = require("../../../../contexts");
var _constants = require("../../constants");
var _ContentRow = require("../ContentRow/ContentRow");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Used to render content rows
 * It generates grid based on the data
 *
 * @constructor
 * @param props
 */ const ContentRows = ()=>{
    const { items } = (0, _productList.useProductList)();
    const { getTestId } = (0, _testidGenerator.default)();
    const { isFocusPage } = (0, _contexts.useBannerProductListingContext)();
    return items.map((data, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.ContentRowRoot, {
            "data-testid": getTestId(_constants.CONTENT_ROWS),
            isFocusPage: isFocusPage,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ContentRow.ContentRow, {
                data: data
            })
        }, index));
};
exports.ContentRows = ContentRows;
